import { ScwError } from "../main";
import { setButtonLoading } from "./loader";

export function onSubmit(
    form: HTMLFormElement,
    handler: (data: FormData, e: SubmitEvent) => Promise<void>,
    submitButton?: HTMLButtonElement | null
) {
    form.addEventListener("submit", async (e) => {
        e.preventDefault();
        if (submitButton) {
            submitButton.disabled = true;
            setButtonLoading(submitButton, true);
        }
        try {
            await handler(new FormData(form, e.submitter), e as SubmitEvent);
        } catch (err) {
            if (!(err instanceof ScwError)) throw err;
        } finally {
            setButtonLoading(submitButton, false);
            if (submitButton && form.isConnected) submitButton.disabled = false;
        }
    });
}

export function onClick(
    button: HTMLButtonElement | null | undefined,
    handler: (e: MouseEvent) => Promise<void>
) {
    button?.addEventListener("click", async (e) => {
        e.preventDefault();
        button.disabled = true;
        setButtonLoading(button, true);
        try {
            await handler(e);
        } catch (err) {
            if (!(err instanceof ScwError)) throw err;
        } finally {
            setButtonLoading(button, false);
            if (button.isConnected) button.disabled = false;
        }
    });
}